import React from 'react';

import { MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ThemedTextField } from 'components/ThemedTextField/ThemedTextField';

import './InputField.sass';

export const InputField = (props) => {
  const {
    oldValue,
    infoText,
    items,
    multiline,
    error,
    value,
    select,
    disabled,
    isEdited,
    fullWidth,
    testId,
    noMaxWidth,
    disablePaste,
    ...filteredProps
  } = props;
  const getClassName = () => {
    if (error) return 'input-field__error';
    if (isEdited || (oldValue && oldValue !== value)) return 'input-field__edited';
    return 'input-field__normal';
  };
  return (
    <div
      className={`${noMaxWidth ? 'input-field__no-max-width' : 'input-field'}  ${
        fullWidth ? 'input-field__full-width' : ''
      }`}>
      <ThemedTextField
        className={getClassName()}
        disabled={disabled}
        error={error}
        value={value}
        select={select}
        multiline={multiline}
        fullWidth={fullWidth}
        data-testid={testId}
        onPaste={disablePaste ? (event) => event.preventDefault() : filteredProps.onPaste}
        {...filteredProps}>
        {select
          ? items.map((item) => (
              <MenuItem
                // className={'input-field__select-menu-items'}
                value={item.value}
                key={item.value}>
                {item.label}
              </MenuItem>
            ))
          : null}
      </ThemedTextField>
      {infoText && (
        <div
          className={`input-field__info-text ${
            disabled ? 'input-field__info-text__disabled' : ''
          }`}>
          {infoText}
        </div>
      )}
    </div>
  );
};
InputField.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  oldValue: PropTypes.string,
  value: PropTypes.string,
  infoText: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  select: PropTypes.bool,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  isEdited: PropTypes.bool,
  testId: PropTypes.string,
  noMaxWidth: PropTypes.bool,
  disablePaste: PropTypes.bool,
};

InputField.defaultProps = {
  items: [],
  oldValue: '',
  value: '',
  infoText: '',
  disabled: false,
  error: false,
  select: false,
  fullWidth: false,
  multiline: false,
  isEdited: false,
  testId: '',
  noMaxWidth: false,
  disablePaste: false,
};
